import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import { WapiService } from 'wanderu-service-wapi';

import { actions as tripDataActions } from '../../appstate';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-ducks-trips:fetchTrip');

export function fetchTrip(tripId, mode, tag) {
    return async (dispatch) => {
        dispatch(actions.startWork(tripId));

        let error;
        try {
            const response = await WapiService.getTrip(tripId);
            const result = { ...response.result, mode: tag };

            return dispatch(tripDataActions.setTrip(tripId, result));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            if (ex.code === 'TRIPS_NOT_FOUND') {
                logger.info('fetchTrip', ex, {
                    snowplowIds: {
                        networkUserId: SnowplowService.getNetworkUserId(),
                        ...domainUserInfo,
                    },
                });
            } else {
                logger.error('fetchTrip', ex, {
                    snowplowIds: {
                        networkUserId: SnowplowService.getNetworkUserId(),
                        ...domainUserInfo,
                    },
                });
            }

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };

            return dispatch(tripDataActions.setTripNotFound(tripId));
        } finally {
            dispatch(actions.endWork(tripId, undefined, error));
        }
    };
}

const fetchTripAction = {
    fetchTrip,
    ...selectors,
};

export {
    fetchTripAction,
};

const fetchTripSlice = {
    [namespace]: reducer,
};
export default fetchTripSlice;
